(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["npx-footer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('npx-site-footer')) {
  customElements.define('npx-site-footer', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.media = window.matchMedia('(max-width: 760px)');
        this.menus = Array.from(this.querySelectorAll('.npx-footer__menu'));
        this.mobileState = new WeakMap();
        this.syncMenus = () => this.menus.forEach((menu) => {
          const mobile = this.media.matches;
          const open = !mobile || this.mobileState.get(menu) === true;
          menu.querySelector('.npx-footer__menu-heading').hidden = mobile;
          const toggle = menu.querySelector('.npx-footer__toggle');
          toggle.hidden = !mobile;
          toggle.setAttribute('aria-expanded', String(open));
          menu.querySelector('.npx-footer__links').hidden = !open;
        });
        this.syncMenus();
        this.media.addEventListener('change', this.syncMenus, { signal });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('.npx-footer__toggle');
          if (!button || !this.media.matches) return;
          const menu = button.closest('.npx-footer__menu');
          this.mobileState.set(menu, button.getAttribute('aria-expanded') !== 'true');
          this.syncMenus();
        }, { signal });
        this.addEventListener('shopify:block:select', (event) => {
          const menu = event.target.closest('.npx-footer__menu');
          if (!menu || !this.menus.includes(menu)) return;
          this.mobileState.set(menu, true);
          this.syncMenus();
        }, { signal });
        const embed = this.querySelector('.npx-footer__embed');
        const loading = this.querySelector('.npx-footer__loading');
        const fallback = this.querySelector('.npx-footer__fallback');
        if (!embed || !loading || !fallback) return;
        fallback.hidden = true;
        loading.hidden = false;
        embed.setAttribute('aria-busy', 'true');
        const ready = () => {
          if (!embed.querySelector('form, input, button, [role="form"]') && !embed.textContent.trim()) return false;
          loading.hidden = true;
          fallback.hidden = true;
          embed.setAttribute('aria-busy', 'false');
          clearTimeout(this.formTimer);
          if (this.observer) this.observer.disconnect();
          return true;
        };
        if (!ready()) {
          this.observer = new MutationObserver(ready);
          this.observer.observe(embed, { childList: true, subtree: true });
          this.formTimer = window.setTimeout(() => {
            if (!this.isConnected || ready()) return;
            loading.hidden = true;
            fallback.hidden = false;
            embed.setAttribute('aria-busy', 'false');
          }, 10000);
        }
      });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      this.controller = null;
      clearTimeout(this.formTimer);
      if (this.observer) this.observer.disconnect();
      this.querySelectorAll('.npx-footer__menu-heading, .npx-footer__links, .npx-footer__fallback').forEach((el) => { el.hidden = false; });
      this.querySelectorAll('.npx-footer__toggle, .npx-footer__loading').forEach((el) => { el.hidden = true; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npx-nx01-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('npx-nx01-hero')) {
  customElements.define('npx-nx01-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.initialize(), { ...options, once: true });
      else this.initialize();
    }
    initialize() {
      if (!this.isConnected || !this.controller || this.initialized) return;
      this.initialized = true;
      const options = { signal: this.controller.signal };
      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('.npx-desc-acc__item');
        if (panel && this.contains(panel) && !panel.open) panel.querySelector('summary')?.click();
      }, options);
      this.form = this.querySelector('.npx-hero__form');
      this.variant = this.querySelector('[data-variant]');
      this.quantity = this.querySelector('[data-quantity]');
      this.add = this.querySelector('[data-add]');
      this.cartAdd = this.querySelector('[data-cart-add]');
      if (!this.form || !this.variant || !this.quantity) return;
      try { this.money = new Intl.NumberFormat(this.dataset.locale || 'en', { style: 'currency', currency: this.dataset.currency || 'AED' }); }
      catch (_) { this.money = new Intl.NumberFormat('en', { style: 'currency', currency: 'AED' }); }
      this.querySelectorAll('[data-quantity-change]').forEach((button) => { button.hidden = false; });
      this.addEventListener('click', (event) => this.onClick(event), options);
      this.variant.addEventListener('change', () => this.update(true), options);
      this.quantity.addEventListener('input', () => this.update(false), options);
      this.quantity.addEventListener('change', () => this.update(false), options);
      this.form.addEventListener('submit', (event) => {
        if (!this.cartAdd || typeof customElements.get('xo-cart-add') === 'undefined') {
          if (this.pending || !this.form.checkValidity() || this.selection().available !== 'true') {
            event.preventDefault();
            return;
          }
          this.pending = true;
          if (this.add) {
            this.add.disabled = true;
            this.add.setAttribute('aria-busy', 'true');
          }
          const addText = this.querySelector('[data-add-text]');
          const status = this.querySelector('[data-status]');
          if (addText) addText.textContent = this.dataset.addingLabel;
          if (status) status.textContent = this.dataset.addingLabel;
          return;
        }
        event.preventDefault();
        if (!this.form.checkValidity() || this.selection().available !== 'true') return;
        this.add?.click();
      }, options);
      window.addEventListener('pageshow', () => this.reset(), options);
      this.reset();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.initialized = false;
    }
    selection() {
      return this.variant.tagName === 'SELECT' ? this.variant.selectedOptions[0].dataset : this.variant.dataset;
    }
    reset() {
      this.pending = false;
      this.add?.removeAttribute('aria-busy');
      const status = this.querySelector('[data-status]');
      if (status) status.textContent = '';
      this.update(false);
    }
    syncCartAdd(selected) {
      if (!this.cartAdd) return;
      this.cartAdd.setAttribute('xo-variant-id', this.variant.value);
      if (selected.available === 'true') this.cartAdd.removeAttribute('xo-disabled');
      else this.cartAdd.setAttribute('xo-disabled', '');
    }
    update(variantChanged) {
      if (this.pending) return;
      const selected = this.selection();
      if (variantChanged) {
        this.quantity.min = selected.min || '1';
        this.quantity.step = selected.step || '1';
        if (selected.max) this.quantity.max = selected.max;
        else this.quantity.removeAttribute('max');
        this.quantity.value = selected.min || '1';
      }
      const valid = this.quantity.checkValidity();
      const amount = Number(this.quantity.value);
      if (valid) {
        const priceLabel = this.querySelector('[data-price-label]');
        const perBottle = this.querySelector('[data-per-bottle]');
        const total = this.querySelector('[data-total]');
        const daily = this.querySelector('[data-daily]');
        const supply = this.querySelector('[data-supply]');
        if (priceLabel) priceLabel.textContent = this.dataset.totalLabel;
        if (perBottle) perBottle.hidden = true;
        if (total) total.textContent = this.money.format(Number(selected.price) * amount / 100);
        if (daily) daily.textContent = this.money.format(Number(selected.price) / 100 / Number(this.dataset.servings));
        if (supply) supply.textContent = String(amount * Number(this.dataset.servings));
      }
      if (this.add) {
        this.add.disabled = selected.available !== 'true';
        const addText = this.querySelector('[data-add-text]');
        if (addText) addText.textContent = this.add.disabled ? this.dataset.soldLabel : this.dataset.addLabel;
      }
      this.syncCartAdd(selected);
      const minus = this.querySelector('[data-quantity-change="-1"]');
      const plus = this.querySelector('[data-quantity-change="1"]');
      if (minus) minus.disabled = valid && amount <= Number(this.quantity.min || 1);
      if (plus) plus.disabled = valid && !!this.quantity.max && amount >= Number(this.quantity.max);
    }
    onClick(event) {
      const quantityButton = event.target.closest('[data-quantity-change]');
      if (quantityButton && !this.pending) {
        if (Number(quantityButton.dataset.quantityChange) > 0) this.quantity.stepUp();
        else this.quantity.stepDown();
        this.quantity.dispatchEvent(new Event('input', { bubbles: true }));
      }
      const thumbnail = event.target.closest('[data-thumb]');
      if (!thumbnail || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      const main = this.querySelector('.npx-hero__photo');
      if (!main) return;
      event.preventDefault();
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = thumbnail.dataset.src;
      main.alt = thumbnail.dataset.alt;
      const mainLink = this.querySelector('[data-main-link]');
      if (mainLink) mainLink.href = thumbnail.href;
      this.querySelectorAll('[data-thumb]').forEach((link) => link.removeAttribute('aria-current'));
      thumbnail.setAttribute('aria-current', 'true');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["npx-peptide-pdp"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('npx-peptide-pdp')) {
  customElements.define('npx-peptide-pdp', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal: this.controller.signal });
      else this.initialize();
    }
    initialize() {
      if (!this.isConnected || this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('.npp-form');
      this.quantity = this.querySelector('[data-quantity]');
      this.add = this.querySelector('[data-add]');
      this.cartAdd = this.querySelector('xo-cart-add');
      this.sticky = this.querySelector('[data-sticky]');
      this.options = [...this.querySelectorAll('[data-option]')];
      this.options.forEach(option => { option.dataset.originalValue = option.value; });
      this.querySelector('[data-option-controls]')?.removeAttribute('hidden');
      this.querySelector('[data-variant-input]').disabled = false;
      this.querySelectorAll('[data-quantity-change]').forEach(button => { button.hidden = false; });
      const listener = { signal: this.controller.signal };
      this.addEventListener('click', event => this.onClick(event), listener);
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option]')) this.changeVariant(event.target.dataset.position);
        if (event.target === this.quantity) this.syncQuantity();
      }, listener);
      this.quantity.addEventListener('input', () => this.syncQuantity(), listener);
      this.addEventListener('click', event => {
        if (event.target.closest('[data-add]') && (!this.form.reportValidity() || this.hasAttribute('aria-busy'))) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...listener, capture: true });
      if (this.sticky && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => {
          this.sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
        });
        this.observer.observe(this.add);
      }
      this.syncQuantity();
    }
    syncQuantity() {
      const valid = this.quantity.checkValidity();
      if (valid) this.cartAdd.setAttribute('xo-product-quantity', this.quantity.value);
      const minus = this.querySelector('[data-quantity-change="-1"]');
      const plus = this.querySelector('[data-quantity-change="1"]');
      if (minus) minus.disabled = valid && Number(this.quantity.value) <= Number(this.quantity.min);
      if (plus) plus.disabled = valid && !!this.quantity.max && Number(this.quantity.value) >= Number(this.quantity.max);
    }
    onClick(event) {
      const quantityButton = event.target.closest('[data-quantity-change]');
      if (quantityButton) {
        if (Number(quantityButton.dataset.quantityChange) > 0) this.quantity.stepUp();
        else this.quantity.stepDown();
        this.syncQuantity();
      }
      if (event.target.closest('[data-sticky-add]')) {
        if (this.form.reportValidity()) this.add.click();
        else this.quantity.focus();
      }
      const thumbnail = event.target.closest('[data-thumb]');
      if (thumbnail && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
        event.preventDefault();
        this.querySelectorAll('[data-media-panel]').forEach(panel => {
          panel.hidden = panel.dataset.mediaPanel !== thumbnail.dataset.thumb;
          if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
        });
        this.querySelectorAll('[data-thumb]').forEach(link => link.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
      }
    }
    async changeVariant(position) {
      this.requestController?.abort();
      const requestController = new AbortController();
      this.requestController = requestController;
      this.setAttribute('aria-busy', 'true');
      this.add.disabled = true;
      this.querySelector('[data-sticky-add]')?.setAttribute('disabled', '');
      this.querySelector('[data-status]').textContent = this.dataset.loadingLabel;
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set('section_id', this.dataset.section);
      url.searchParams.set('option_values', this.options.map(option => option.value).join(','));
      try {
        const response = await fetch(url, { signal: requestController.signal });
        if (!response.ok) throw new Error('Variant request failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = page.querySelector('npx-peptide-pdp');
        if (!next || next.dataset.section !== this.dataset.section) throw new Error('Product section missing');
        const quantity = next.querySelector('[data-quantity]');
        quantity.value = this.quantity.value;
        if (!quantity.checkValidity()) quantity.value = quantity.min || '1';
        const selectedUrl = new URL(window.location.href);
        if (next.dataset.variantId) {
          selectedUrl.searchParams.set('variant', next.dataset.variantId);
          selectedUrl.searchParams.delete('option_values');
        } else {
          selectedUrl.searchParams.delete('variant');
          selectedUrl.searchParams.set('option_values', this.options.map(option => option.value).join(','));
        }
        window.history.replaceState({}, '', selectedUrl);
        this.replaceWith(next);
        next.querySelector(`[data-option][data-position="${position}"]`)?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.removeAttribute('aria-busy');
        this.options.forEach(option => { option.value = option.dataset.originalValue; });
        this.add.disabled = this.cartAdd.hasAttribute('xo-disabled');
        const stickyAdd = this.querySelector('[data-sticky-add]');
        if (stickyAdd) stickyAdd.disabled = this.add.disabled;
        this.querySelector('[data-status]').textContent = this.dataset.errorLabel;
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.requestController?.abort();
      this.observer?.disconnect();
      this.controller = null;
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx01-faqs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('npx-nx01-faq')) {
    customElements.define(
      'npx-nx01-faq',
      class extends HTMLElement {
        connectedCallback() {
          queueMicrotask(() => {
            if (!this.isConnected || this.controller) return;
            this.controller = new AbortController();
            const signal = this.controller.signal;
            this.items = Array.from(this.querySelectorAll('.npx-faq__item'));
            this.limit = Math.max(1, Number(this.dataset.initialCount) || 8);
            this.extra = this.items.slice(this.limit);
            this.button = this.querySelector('.npx-faq__more');
            this.expanded = false;
            if (this.button && this.extra.length) {
              this.setExpanded(false);
              this.button.hidden = false;
              this.button.addEventListener(
                'click',
                () => {
                  const opening = !this.expanded;
                  this.setExpanded(opening);
                  if (opening) {
                    const firstExtra = this.extra[0].querySelector('summary');
                    if (firstExtra) firstExtra.focus({ preventScroll: true });
                  }
                },
                { signal }
              );
            }
            this.addEventListener(
              'click',
              (event) => {
                const summary = event.target.closest('.npx-faq__summary');
                const active = summary && summary.parentElement;
                if (active && this.items.includes(active) && !active.open) this.closeOthers(active);
              },
              { signal }
            );
            this.addEventListener(
              'toggle',
              (event) => {
                const active = event.target;
                if (!this.items.includes(active) || !active.open) return;
                this.closeOthers(active);
              },
              { capture: true, signal }
            );
            this.addEventListener(
              'shopify:block:select',
              (event) => {
                const active = event.target.closest('.npx-faq__item');
                if (!active || !this.items.includes(active)) return;
                if (active.hidden) this.setExpanded(true);
                this.closeOthers(active);
                active.open = true;
              },
              { signal }
            );
          });
        }

        closeOthers(active) {
          if (this.dataset.singleOpen !== 'true') return;
          this.items.forEach((item) => {
            if (item !== active) item.open = false;
          });
        }

        setExpanded(expanded) {
          this.expanded = expanded;
          this.extra.forEach((item) => {
            if (!expanded) item.open = false;
            item.hidden = !expanded;
          });
          if (!this.button) return;
          this.button.setAttribute('aria-expanded', String(expanded));
          const moreLabel = this.button.querySelector('[data-more-label]');
          const lessLabel = this.button.querySelector('[data-less-label]');
          if (moreLabel) moreLabel.hidden = expanded;
          if (lessLabel) lessLabel.hidden = !expanded;
        }

        disconnectedCallback() {
          if (this.controller) this.controller.abort();
          this.controller = null;
          if (this.items) this.items.forEach((item) => { item.hidden = false; });
          if (this.button) this.button.hidden = true;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["topics-index"] && !Shopify.designMode) return;
  try {
    
  const initializeTopicsIndex = (root) => {
    if (!root || root.dataset.topicsInitialized === 'true') return;

    const input = root.querySelector('[data-topics-filter]');
    const cards = Array.from(root.querySelectorAll('[data-topic-card]'));
    const empty = root.querySelector('[data-topics-filter-empty]');
    const status = root.querySelector('[data-topics-status]');

    if (!input || cards.length === 0) return;

    root.dataset.topicsInitialized = 'true';

    input.addEventListener('input', () => {
      const query = input.value.trim().toLocaleLowerCase();
      let visibleCount = 0;

      cards.forEach((card) => {
        const matches = query === '' || card.dataset.topicFilterValue.includes(query);
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      if (empty) empty.hidden = visibleCount !== 0;
      if (status) status.textContent = `${visibleCount} topic${visibleCount === 1 ? '' : 's'} shown`;
    });
  };

  const initializeAllTopicsIndexes = (scope = document) => {
    scope.querySelectorAll('[data-topics-index]').forEach(initializeTopicsIndex);
  };

  initializeAllTopicsIndexes();
  document.addEventListener('shopify:section:load', (event) => initializeAllTopicsIndexes(event.target));

  } catch(e) { console.error(e); }
})();
})();
